/**
 * 주 입력이 터치인 기기(폰·태블릿)인지 — 화면 폭이 아니라 **입력 기기** 기준이다.
 * 아이패드는 넓어도 터치이고, 터치스크린 노트북(주 포인터 fine)은 창을 좁혀도 마우스 기기다.
 * 레이아웃 분기는 이 상수가 아니라 useIsMobile()(matchMedia 767px)을 쓴다 — 두 축은 별개다.
 *
 * 기기 특성이라 세션 중 바뀌지 않으므로 모듈 로드 시 1회만 평가한다(훅·리스너 불필요).
 * 이 판정이 필요한 곳은 전부 여기서 import한다 — 호출을 복붙하면 조용히 갈라진다.
 */
export const IS_COARSE_POINTER = window.matchMedia('(pointer: coarse)').matches;
